import React from 'react';
import PropTypes from 'prop-types';
import TabGroup from './ui/TabGroup';
import LiveEventModalDetails from './LiveEventModalDetails';
import LiveEventModalEngagement from './LiveEventModalEngagement';
import LiveEventModalElements from './LiveEventModalElements';
import LiveEventModalEmbed from './LiveEventModalEmbed';


class LiveEventModal extends React.Component{

    state = {
        event: {...this.props.event},
        currentTab: 'Details'
    };

    changeTab = (tab) => {
        this.setState({ currentTab: tab });
    };

    updateEvent = (key, value) => {
        const event = {...this.state.event};
        event[key] = String(value);
        this.setState({event});
    };

    saveEvent = (e) => {
        e.preventDefault();
        const event = this.state.event;
        this.props.updateEvent(event, this.props.eventKey);
    };

    addRepeatItem = (itemName) => {
        const event = {...this.state.event};
        const timestamp = Date.now();
        if(!event[itemName]) {
            event[itemName] = {};
        }
        event[itemName][timestamp] = {};
        this.setState({event});
    };

    removeRepeatItem = (itemName, id) => {
        const event = {...this.state.event};
        event[itemName][id] = null;
        this.setState({event});
    };

    updateRepeatItem = (itemName, id, item) => {
        const event = {...this.state.event};
        if(!event[itemName][id]) {
            event[itemName][id] = {};
        }
        event[itemName][id] = {'mins': item.keyName, 'tag': item.value};
        this.setState({event});
    };

    renderTitle = () => {
        if(this.props.newEvent) {
            return 'Add event';
        } else {
            return 'Edit event';
        }
    };

    renderTabPanels = () => {
        switch(this.state.currentTab) {
            case 'Details':
                return <LiveEventModalDetails event={this.state.event} updateEvent={this.updateEvent} />;
            case 'Page elements':
                return <LiveEventModalElements event={this.state.event} updateEvent={this.updateEvent} />;
            case 'Engagement':
                return <LiveEventModalEngagement event={this.state.event} updateEvent={this.updateEvent} addDuration={this.addRepeatItem} updateDuration={this.updateRepeatItem} removeDuration={this.removeRepeatItem}/>;
            case 'Embed':
            return <LiveEventModalEmbed event={this.state.event} eventKey={this.props.eventKey} />;
            default:
                return null;
        }
    };

    render() {
        return (
            <div className="modal" role="dialog" onClick={this.props.closeLiveEventModal}>
                <div className="modal-dialog modal-lg" role="document" onClick={(e) => {e.stopPropagation()}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.renderTitle()}</h5>
                            <button type="button" className="close" onClick={this.props.closeLiveEventModal}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form ref={(input) => this.form = input} onSubmit={(e) => {this.saveEvent(e)}}>
                            <div className="modal-body">
                                <TabGroup tabs={['Details', 'Page elements', 'Engagement', 'Embed']} currentTab={this.state.currentTab} onChange={this.changeTab} />

                                {this.renderTabPanels()}
                            </div>
                            <div className="modal-footer flex-between">
                                {this.props.newEvent ? <div /> : <button type="button" className="btn btn-primary btn-with-icon btn-delete" onClick={e => this.props.deleteEvent(this.props.eventKey)}><i className="material-icons">delete</i>Delete</button>}

                                <div>
                                    <button type="button" className="btn btn-secondary btn-with-icon" onClick={this.props.closeLiveEventModal}><i className="material-icons">cancel</i>Cancel</button>
                                    <button type="submit" className="btn btn-primary btn-with-icon"><i className="material-icons">save</i>Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

LiveEventModal.propTypes ={
    event: PropTypes.object.isRequired,
    eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeLiveEventModal: PropTypes.func.isRequired,
    deleteEvent: PropTypes.func.isRequired,
    updateEvent: PropTypes.func.isRequired,
    newEvent: PropTypes.bool.isRequired
}

export default LiveEventModal;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEventModal.js
 **/